'use strict';

var _ = require('lodash');
var ConfigurationMarketAssignService = function ConfigurationMarketAssignService(restangular, featureToggleService) {
  var rulesAPI = restangular.service('configuration').one('hep').one('marketentityassignment');
  function save(data) {
    data.forEach(function (assignment) {
      delete assignment.uid;
      delete assignment._old;
      delete assignment._original;
      delete assignment.originalRowId;
      delete assignment._links;
      assignment.isSignificant = assignment.isSignificant === 'Yes' || assignment.isSignificant === true;
      assignment.isTrafficRestricted = assignment.isTrafficRestricted === 'Yes' || assignment.isTrafficRestricted === true;
      assignment.isFimAlertEnabled = _.isUndefined(assignment.isFimAlertEnabled) || assignment.isFimAlertEnabled === 'Yes' || assignment.isFimAlertEnabled === true;
      assignment.isInterline = _.isUndefined(assignment.isInterline) || assignment.isInterline === 'Yes' || assignment.isInterline === true;
      if (featureToggleService.isEnabled('MARKET_LOCAL_INDICATOR')) {
        assignment.isLocal = assignment.isLocal === 'Yes' || assignment.isLocal === true;
      } else {
        assignment.isLocal = assignment.isSignificant;
      }
    });
    return rulesAPI.customPOST(data);
  }
  return {
    save: save
  };
};
ConfigurationMarketAssignService.$inject = ['Restangular', 'FeatureToggleService'];
module.exports = ConfigurationMarketAssignService;